<button class="close" style="float: right;
min-width: auto;" mat-button (click)="onNoClick()">X</button>
<h2>Resumen de Elementos de Gestión y Medios de Verificación</h2>
<mat-dialog-content>
    <table class="medio-verificacion">
        
        <tr>
            <!-- <th>N°</th>   -->
            <th>NOMBRE ARCHIVO</th>  
            <th>ELEMENTO DE GESTIÓN</th>  
            <th>COMENTARIO</th> 
            <th>DESCARGAR</th>  
        </tr>
        
        <ng-container *ngFor="let area of autoEvaluacion; let a = index">
            <ng-container *ngFor="let dimension of area.dimensiones; let d = index">
                <ng-container *ngFor="let elemento of dimension.elementos; let e = index">      
                    <ng-container *ngFor="let vinculado of elemento.vinculados; let v = index">                
                        <tr>
                            <!-- <td>{{v}}</td>   -->
                            <td>{{vinculado.nombre}}</td> 
                            <td><b>{{dimension.nombreCorto}}.</b> {{elemento.elementoGestion}}</td> 
                            <td>{{vinculado.comentario}}</td> 
                            <td> 
                                <img (click)="descargarMedio(vinculado.idMedioVerificacion)" style="width: 35px;margin: 5px;cursor: pointer;" src="../../../.././../../assets/icons/JUNJI_download.svg" >
                            </td> 
                        </tr>
                </ng-container>
                </ng-container>
            </ng-container>        
        </ng-container>

    </table>
</mat-dialog-content>
